import React, { useEffect } from 'react';
import { PropTypes } from 'prop-types'
import { useRouteMatch } from 'react-router-dom'
import './Layout.scss'
import Header from './Header';
import Footer from './Footer';

const AppContainer = ({ children }) => {
    const { url } = useRouteMatch()

    useEffect(() => {
        var el = document ? document.getElementById("overflow-container") : null;
        if (el) {
            el.scrollTop = 0
        }
    }, [url]);

    return (
        <div id='app-container'>
            <Header />
            <div id='content-wrapper'>
                <div id='overflow-container'>
                    <div id='overflow-content'>
                        {children}
                    </div>
                    <Footer />
                </div>
            </div>
        </div>
    );
}

AppContainer.propTypes = {
    children: PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.node),
        PropTypes.node
    ]).isRequired 
}

export default AppContainer